import * as React from "react";
import { useEffect, useRef } from "react";
import styled, { css } from "styled-components";
import { Button } from "components/bootstrap";
import Icon from "components/common/Icon";
import Spinner from "components/common/Spinner";
import ModalButtonToolbar from "components/common/ModalButtonToolbar";
const Container = styled.div(
  ({ $hasLeftCol }) => $hasLeftCol && css`
      display: flex;
      justify-content: space-between;
      align-items: end;
    `
);
const buttonTitle = (isSubmitting, submitText, submitLoadingText) => {
  if (isSubmitting && typeof submitLoadingText === "string") {
    return submitLoadingText;
  }
  if (!isSubmitting && typeof submitText === "string") {
    return submitText;
  }
  return void 0;
};
const isWithCancelProps = (props) => props.displayCancel === void 0 || props.displayCancel === true;
const isWithAsyncSubmit = (props) => props.isAsyncSubmit === true;
const ModalSubmit = ({ ...props }) => {
  const {
    autoFocus = false,
    bsSize,
    className,
    disabledSubmit = false,
    formId,
    leftCol,
    onSubmit,
    submitButtonText,
    submitButtonType = "submit",
    submitIcon
  } = props;
  const submittingAsync = isWithAsyncSubmit(props) && props.isSubmitting;
  const title = buttonTitle(
    submittingAsync,
    submitButtonText,
    "submitLoadingText" in props ? props.submitLoadingText : void 0
  );
  const confirmRef = useRef();
  useEffect(() => {
    if (autoFocus && !disabledSubmit && confirmRef.current) {
      confirmRef.current.focus();
    }
  }, []);
  return /* @__PURE__ */ React.createElement(Container, { $hasLeftCol: !!leftCol, className }, leftCol, /* @__PURE__ */ React.createElement(ModalButtonToolbar, null, isWithCancelProps(props) && /* @__PURE__ */ React.createElement(
    Button,
    {
      type: "button",
      bsSize,
      onClick: props.onCancel,
      title: "Cancel",
      "aria-label": "Cancel",
      disabled: props.disabledCancel || submittingAsync
    },
    "Cancel"
  ), /* @__PURE__ */ React.createElement(
    Button,
    {
      ref: confirmRef,
      bsStyle: "primary",
      bsSize,
      disabled: disabledSubmit || submittingAsync,
      form: formId,
      title,
      "aria-label": title,
      type: submitButtonType,
      onClick: onSubmit
    },
    submitIcon && !submittingAsync && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Icon, { name: submitIcon }), " "),
    submittingAsync ? /* @__PURE__ */ React.createElement(Spinner, { text: props.submitLoadingText, delay: 0 }) : submitButtonText
  )));
};
export default ModalSubmit;
